import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter } from "react-router-dom";
import { Toaster } from "sonner";
import { App } from "./App";
import { LocaleProvider } from "./app/LocaleProvider";
import { queryClient } from "./lib/query-client";
import "./index.css";

const root = document.getElementById("root");
if (!root) throw new Error("#root is missing from index.html");

createRoot(root).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      {/*
        `useTransitions={false}` is the fix for the modal-to-modal flash, and it is not a
        performance tweak — it is what makes a navigation *replace* what is on screen.

        React Router 7's `BrowserRouter` wraps every location update in
        `React.startTransition` by default (`setState` in its source; the prop is the
        library's own opt-out). A transition render is interruptible and time-sliced, and
        while it runs React keeps the **previously committed tree** painted. So opening a
        detail from inside another detail flipped the URL immediately and then left the
        *previous* record's modal fully on screen for the whole render — measured at ~60ms,
        four 60Hz frames, in four ~10ms slices — before the new modal appeared. The reader
        clicks a client name and keeps reading the opportunity.

        Nothing here asks for transition semantics: there is no Suspense boundary, no lazy
        route, no `isPending` affordance anywhere in the app, and no data router. So the
        transition bought no stale-while-loading UI we use, and cost exactly one defect.
        Without it the location update lands in the default lane: the previous modal is torn
        down and the new route's first designed state commits in the same frame as the click.

        Keep the four designed states in the modals — with transitions off, the *loading*
        state is what a reader sees while a record fetches, which is the honest answer.
      */}
      <BrowserRouter useTransitions={false}>
        {/* Inside the router because the session query is a query like any other, and
            outside `App` because the sign-in screens need a language too. */}
        <LocaleProvider>
          <App />
          {/* Bottom-centre: a move's confirmation rises from the edge of the screen rather
              than over the board's right-hand quarters, which is where a dragged card
              most often lands. */}
          <Toaster position="bottom-center" richColors closeButton />
        </LocaleProvider>
      </BrowserRouter>
    </QueryClientProvider>
  </StrictMode>,
);
